/* tslint:disable */
/* eslint-disable */
/**
 * Cryptix API
 * The Cryptix API is organized around [REST](https://wikipedia.org/wiki/REST).  ## HTTP response status codes |Status Code | Description| |---|---| |[200 OK](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/200) | The request is successful.| |[202 Accepted](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/202) | The server accepted the request and will execute it later. | |[401 Unauthorized](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/401)| Indicates that the client request has not been completed because it lacks valid authentication credentials for the requested resource.| |[403 Forbidden](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/403)| Indicates that the server understands the request but refuses to authorize it.| |[404 Not Found](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/404)| Indicates that the server cannot find the requested resource.| |[405 Method Not Allowed](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/405)| Indicates that the server knows the request method, but the target resource doesn\'t support this method.| |[422 Unprocessable Content](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/422)| Returned when the validation of the resource fails on POST or PUT requests. Response contains errors field with a list of errors.| |[429 Too Many Requests](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/429)| Indicates the user has sent too many requests in a given amount of time (\"rate limiting\").| |[500 Internal Server Error](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/500)| Server error.|  ## Error Codes |Error Code | Description| |---|---| | `authentication_required` | Indicates that the client request has not been completed because it lacks valid authentication credentials for the requested resource. | | `rate_limit_exceeded`     | Indicates the user has sent too many requests in a given amount of time (\"rate limiting\"). | | `validation_error`     | Request validation error. Response contains errors field with a list of errors. | | `insufficient_balance` | The operation could not be completed because the associated account does not have a sufficient balance available. Create a new operation using an amount less than or equal to the account\'s available balance. | | `amount_too_small`     | The specified amount is less than the minimum amount allowed. Use a higher amount (or change fee payer) and try again. | --- 
 *
 * The version of the OpenAPI document: v2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from "./configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';

export const BASE_PATH = "https://api.cryptix.io".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}
